import algoliaSearch, { SearchIndex } from 'algoliasearch';
import {
	SearchForFacetValuesResponse,
	SearchOptions,
	SearchResponse,
} from '@algolia/client-search';
import { ALGOLIA_API_KEY, ALGOLIA_APPLICATION_ID, ALGOLIA_ENV } from 'src/utilities/envConfig';
import { OptimizelyDecision } from '@optimizely/react-sdk';
import { getRolesToDisplay } from '@src/constants/featureFlags';

export const algoliaClient = algoliaSearch(ALGOLIA_APPLICATION_ID, ALGOLIA_API_KEY);

export const getIndexName = (decision: OptimizelyDecision): string => {
	const rolesToDisplay = getRolesToDisplay(decision);
	if (rolesToDisplay) {
		return `${ALGOLIA_ENV}-program-index-v2-${rolesToDisplay}-roles`;
	}
	return `${ALGOLIA_ENV}-program-index-v2`;
};

let algoliaIndex: SearchIndex = null;
function loadIndex(indexName: string) {
	if (!algoliaIndex || algoliaIndex.indexName !== indexName) {
		algoliaIndex = algoliaClient.initIndex(indexName);
	}
	return algoliaIndex;
}

export interface MultiIndexQueryParams {
	indexName: string;
	query: string;
	params: SearchOptions;
}

// Index operations
export const search = async (
	query: string,
	params: SearchOptions,
	indexName: string
): Promise<SearchResponse> => {
	const index = loadIndex(indexName);
	const results = await index.search(query, {
		...params,
		getRankingInfo: true,
	});
	return results;
};

export const getAcademicPartnerIndexName = () => {
	const indexName = `${ALGOLIA_ENV}-academic-partners`;
	return indexName;
};

export const DPPAlgoliaListFacetFilters = [['merchandisingTier:affiliate'], ['active:true']];
export const activeSchoolsFilter = [['active:true']];

let academicPartnerIndex: SearchIndex = null;
export const getAcademicPartnerIndex = () => {
	if (!academicPartnerIndex) {
		const indexName = getAcademicPartnerIndexName();
		academicPartnerIndex = algoliaClient.initIndex(indexName);
	}
	return academicPartnerIndex;
};

export const searchForFacetValues = async (
	facetName: string,
	facetQuery: string,
	params: SearchOptions,
	indexName: string
): Promise<SearchForFacetValuesResponse> => {
	const index = loadIndex(indexName);
	const facetValues = await index.searchForFacetValues(facetName, facetQuery, params);
	return facetValues;
};
